// A set for the stage, in electro house: the leads and the bass lines are
// kept in lists and chosen by number while it plays. Press Stage: the
// buttons pick from each list (or Alt+1 to Alt+4); random draws one every
// time round, all plays them in order.
tempo: 126
key: G minor

list leads {
  | g4 _ [bb4 d5] _ | f5 _ [d5 bb4] c5 |
  | [g5 g5] [- f5] [- d5] [- c5] | d5 bb4 g4 _ |
  | d5 d5 [- d5] [eb5 d5] | c5 _ bb4 _ |
  | g4 bb4 d5 g5 | f5 d5 bb4 f4 |
}
list basses {
  | [g1 g2] [- g1] [g2 g1] [- g2] | [eb1 eb2] [- eb1] [f1 f2] [- f1] |
  | g1 _ [- g1] [bb1 c2] | eb1 _ [- f1] [f1 d2] |
  | [g1 -] [g2 -] [g1 -] [g2 f2] | [eb2 -] [eb1 -] [f1 -] [f2 d2] |
}

lead: synth.saw -> delay -> reverb
lead = leads.1
lead.volume = 0.5
lead.delay.sync = 0.75
lead.delay.mix = 0.3

bass: bass.synth -> lowpass
bass = basses.1
bass.lowpass.cutoff = 1100 Hz

stab: poly.rave_chord_stab -> drive -> lowpass
stab = | - [- g3+bb3+d4] - [- g3+bb3+d4] | - [- eb3+g3+bb3] - [- f3+a3+c4] |
stab.drive.amount = 10 dB
stab.lowpass.cutoff = 2400 Hz
stab.volume = 0.45

drums: drums.909
drums {
  bd   = b b b b
  oh   = -o -o -o -o
  clap = - p - p
  hh   = cccc cCcc cccc cCcc
}
